import { MainLayout } from '@layouts';
import { GenericErrorPage } from '@pages/error';
import React, { Component, ReactNode } from 'react';
interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

class ErrorBoundary extends Component<Props, State> {
  public state: State = {
    hasError: false
  };

  public static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  public render() {
    if (this.state.hasError) {
      return (
        <MainLayout>
          <React.Fragment>
            <GenericErrorPage />
          </React.Fragment>
        </MainLayout>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
